import BulkPermissionsDashboard from './User';

export default BulkPermissionsDashboard;
